// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"process-state-form_submitBtn__JBOAq"};